module.exports = __webpack_public_path__ + "static/chopsticks-flower-8d8d3911b5d4aaa9e877c3e4acc94e23.svg";